<template lang="pug">
  .pRow
    .pRow__chatBody.d-inline-block.position-relative
      .chatBody__outSideBox
        .row.flex-row-reverse.no-gutters.align-items-start.flex-nowrap
          .pRow__profileImg.ml-3(
            v-if="this.profile_picture",
            @click="showLightBox(profile_picture)"
          )
            ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
              :profileUrl="this.profile_picture",
              :style="{ 'width': '50px', 'height': '50px' }"
            )
          .d-flex.align-items-end.flex-nowrap.flex-row-reverse.no-gutters
            .pRow__content.pRow__videoBox.position-relative.d-flex.align-items-center
              .videoBox__insidevideoBox
                video.w-100.rounded(
                  controls,
                  :poster="this.messageData.previewImage ? this.messageData.previewImage : null"
                )
                  source(
                    :src="this.messageData.url",
                    type="video/mp4"
                  )
                  source(
                    :src="this.messageData.url",
                    type="video/ogg"
                  )
                  | Your browser does not support the video tag.
            .pRow__timeBox
              span.text-right(
                v-if="this.messageData.is_read"
              ) 已讀
              span.cursor-default.text-right {{ filterToday(this.messageData.time) }}
</template>

<script>
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';

export default {
  name: 'P-Video',
  components: {
    ProfilePhotoSticker
  },
  props: {
    messageData: {
      type: Object,
      required: true
    },
    profile_picture: {
      type: String,
      default: null
    }
  },
  methods: {
    // 通知父組件顯示幻燈片
    showLightBox(imageUrl) {
      this.$emit('showLightBox', imageUrl);
    }
  }
};
</script>

<style>

</style>
